import { render, staticRenderFns } from "./SucursalDetalle.vue?vue&type=template&id=473879e4&scoped=true"
import script from "./SucursalDetalle.vue?vue&type=script&lang=js"
export * from "./SucursalDetalle.vue?vue&type=script&lang=js"
import style0 from "./SucursalDetalle.vue?vue&type=style&index=0&id=473879e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473879e4",
  null
  
)

export default component.exports